import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AppSettingsService, OrtakService } from '@dabnet-kamu/libs/ui';
import { AuthService } from './auth.service';
import {Observable, catchError, from, map, of, switchMap, filter, take} from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { User } from 'oidc-client';
import { environment } from 'libs/ui/src/lib/environments/environment';
import devices from 'devextreme/core/devices';
import { NotificationService } from '@dabnet-kamu/libs/ui/shared/services/notification.service';

/** Girişe gönderilmeden önce gidilmek istenen adres burada saklanır; LoginCallbackComponent giriş bitince oraya döner. */
export const DONUS_URL_ANAHTARI = 'dk-donus-url';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private appSettingsService: AppSettingsService,
    private authService: AuthService,
    private ortakService: OrtakService,
    private router: Router,
    private injector: Injector
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {

    return this.appSettingsService.settings$.pipe(
      filter(Boolean),
      take(1),

      // eski hâli (13.10.2026): isLoggedIn$ BehaviorSubject(null)'dan türüyor; initializeUser() (getUser) asenkron
      // bittiğinden guard ilk değeri (null) alıp "oturum yok" sanıyordu. Adres çubuğundan açılan /main/xyz,
      // yeni sekme ve yenileme fark edilmeyen bir giriş turuyla ana sayfaya düşüyordu.
      // switchMap(() => this.authService.isLoggedIn$()),
      // take(1),
      // Kullanıcının depodan yüklenmesi beklenir; süresi dolmuşsa önce sessiz yenileme denenir
      switchMap(() => from(this.authService.userManager.getUser())),
      switchMap(user => this.gecerliKullaniciVar(user)),

      switchMap(isLoggedIn => {
        if (!isLoggedIn) {
          // Giriş dönüşünde aynı sayfaya gelinsin (LoginCallbackComponent okur)
          try { sessionStorage.setItem(DONUS_URL_ANAHTARI, state.url); } catch { /* gizli pencere vb. */ }
          this.authService.startAuthentication();
          return of(false);
        }

        return this.ortakService
          .getKullaniciBilgi(devices.current().deviceType)
          .pipe(
            map(res => {
              localStorage.setItem(
                'kullanici',
                JSON.stringify(res.kullaniciBilgi)
              );

              // e-belediye istisnası
              if (!res.isKullanici && environment.projectNameEbld !== 'e-belediye') {
                return this.router.createUrlTree(['no-auth']);
              }

              return true;
            }),
            catchError(() => {
              return of(this.router.createUrlTree(['/error']));
            })
          );
      }),

      catchError(() => {
        return of(this.router.createUrlTree(['/error']));
      })
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  /**
   * Depodan yüklenen kullanıcı geçerli mi. Geçerliyse AuthService'e de verilir (initializeUser'ı beklemeden token hazır olsun).
   * Süresi dolmuşsa ensureValidUser() ile bir kez sessiz yenileme denenir; olmazsa false (girişe gidilir).
   */
  private gecerliKullaniciVar(user: User | null): Observable<boolean> {
    if (user && !user.expired) {
      if (!this.authService.loggedUser) this.authService.userSubject.next(user);
      return of(true);
    }
    if (!user) return of(false);
    return from(this.authService.ensureValidUser()).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}



// @Injectable({
//   providedIn: 'root',
// })
// export class AuthGuard implements CanActivate, CanActivateChild {
//   constructor(
//     private appSettingsService: AppSettingsService,
//     private injector: Injector,
//     private router: Router,
//     private ortakService: OrtakService
//   ) {}
//
//   canActivateChild(
//     childRoute: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ):
//     | boolean
//     | UrlTree
//     | Observable<boolean | UrlTree>
//     | Promise<boolean | UrlTree> {
//     return this.appSettingsService.settings$.pipe(
//       switchMap((settings) => {
//         const authService = this.injector.get(AuthService);
//
//         return authService.getUserInfo().pipe(
//           map((loggedIn) => {
//             if (!loggedIn) {
//               authService.startAuthentication();
//               return false;
//             }
//             return true;
//           })
//         );
//       }),
//       catchError((error) => {
//         console.error(
//           'Error loading settings or during user authentication:',
//           error
//         );
//         this.router.navigate(['/error']);
//         return of(false);
//       })
//     );
//   }
//
//   canActivate(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<boolean> | Promise<boolean> | boolean {
//     return this.appSettingsService.settings$.pipe(
//       switchMap((settings) => {
//         const authService = this.injector.get(AuthService);
//
//         return authService.getUserInfo().pipe(
//           switchMap((loggedIn) => {
//             if (!loggedIn) {
//               authService.startAuthentication();
//               return of(false); // Authentication başlamadıysa false döner
//             }
//             if(loggedIn.expired){
//              // authService.startLogout();
//             }
//
//             authService.userManager.events.addUserSessionChanged(() => {
//             });
//
//             authService.userManager.events.addUserSignedOut(() => {
//               authService.startLogout();
//             });
//
//             return this.ortakService.getKullaniciBilgi(devices.current().deviceType).pipe(
//               map((res) => {
//                 localStorage.setItem(
//                   'kullanici',
//                   JSON.stringify(res.kullaniciBilgi)
//                 );
//                 this.injector.get(NotificationService)
//                 //e-belediyenin logininin çalışması için burası gerekli
//                 if (!res.isKullanici && environment.projectNameEbld !== 'e-belediye') {
//                   const router = this.injector.get(Router);
//                   router.navigateByUrl('no-auth'); // Yönlendirme yapılır
//                   return false;
//                 }
//
//                 return true; // Kullanıcı yetkiliyse true döner
//               })
//             );
//           })
//         );
//       }),
//       catchError((error) => {
//         console.error(
//           'Error loading settings or during user authentication:',
//           error
//         );
//         this.router.navigate(['/error']);
//         return of(false); // Hata durumunda false döner
//       })
//     );
//   }
//
// }
